// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "chartkick/chart.js"
import "./src/turbo_config"
import * as bootstrap from "bootstrap"
import "@37signals/lexxy"
import "@rails/activestorage"
import "@rails/actiontext"
